<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>商品邮费设置</span>
				<el-button class="button" @click='edit("")' type="success">新增商品邮费</el-button>
			</div>
		</template>
		<div class="col">
			<el-table :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" empty-text="暂无数据" v-loading="loading" :data="productSetShipData.filter(data => !search || data.product_sale_name.toLowerCase().includes(search.toLowerCase()))"
			 style="width: 100%;" :default-sort="sort" border highlight-current-row>
				<el-table-column prop="id" label="编号" sortable width="180">
				</el-table-column>
				<el-table-column label="商品类型名称">
					<template #default="scope">
						<span>{{scope.row.product_sale_name}}</span>
					</template>
				</el-table-column>
				<el-table-column label="邮费区间(按照商品数量设置邮费价格)">
                    <template #default="scope">
                        <el-table :data="scope.row.product_set_shipping" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}"  height="250">
                            <el-table-column prop="purchase_quanities" label="商品数量(件)"></el-table-column>
                            <el-table-column prop="product_set_shipping" label="邮费价格"></el-table-column>
                        </el-table>
                    </template>
				</el-table-column>
				<el-table-column align="right">
					<template #header>
						<el-input v-model="search" size="medium" placeholder="输入商品类型名称" />
					</template>
					<template #default="scope">
						<el-button type="primary" size="medium" @click="edit(scope.row)">编辑</el-button>
						<el-button v-if="this.localGet('userId')==1" type="danger" size="medium" @click="destroy(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible">
		<template #title>
			<el-row type="flex" class="row-bg"  justify="start">
				<el-col :span="6">
					<span>{{title}}</span>
				</el-col>
				<el-col :span="3">
					<el-button :disabled="disabled_add" size="medium" type="success" @click="onAdd">添加</el-button>
				</el-col>
			</el-row>
		</template>
		<el-form label-position='left' :model="item" ref="form" :rules="rules" label-width="120px">
			<el-form-item label="商品类型" prop="product_sale_type">
				<el-select :disabled="disabled_update" filterable v-model="item.product_sale_type" clearable placeholder="请选择">
					<el-option v-for="item in all_product_sale_type" :key="item.id" :label="item.product_sale_name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-row type="flex" :gutter="20" justify="center">
				<el-col :span="3">
					<div class="grid-content bg-purple">商品邮费</div>
				</el-col>
				<el-col :span="9">
					<div class="grid-content bg-purple">商品数量</div>
				</el-col>
				<el-col :span="9">
					<div class="grid-content bg-purple">邮费价格</div>
				</el-col>
				<el-col :span="3">
					<div class="grid-content bg-purple">操作</div>
				</el-col>
			</el-row>
			<el-form-item :label='"邮费"+(key+1)' v-for='(items,key) in item.productSetShipping' :key='key'>
				<el-row type="flex" :gutter="20" justify="start">
					<el-col :span="10">
						<el-form-item 
                            :prop="'productSetShipping.' + key + '.purchase_quanities'"
                             :rules="rules.purchase_quanities">
							<el-input v-model.number="items.purchase_quanities" placeholder="商品数量" autocomplete="off"></el-input>
                        </el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item 
					        :prop="'productSetShipping.' + key + '.product_set_shipping'"
					         :rules="rules.product_set_shipping">
							<el-input v-model.number="items.product_set_shipping" placeholder="邮费价格" autocomplete="off"></el-input>
					    </el-form-item>
					</el-col>
					<el-col :span="4">
						<el-button size="medium" type="danger" @click="removeDomain(key)">删除</el-button>
					</el-col>
				</el-row>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
			<el-button size="small" type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default{
		name:'ProductSetShipping',
		data(){
			return {
				title: '新增商品邮费',
				dialogFormVisible: false,
				loading:true,
				productSetShipData:[],
				search: '',
				sort: {
					prop: 'id',
					order: 'descending'
				},
				disabled_add:false,
				disabled_update:false,
				all_product_sale_type:[],
				item:{
					productSetShipping:[],
					product_sale_type:'',
				},
				rules:{
					purchase_quanities:[{
						required: true,
						message: '商品数量不能为空',
						trigger: 'blur'
					},{
						type: 'number', 
						message: '商品数量必须为数字值'
					}],
					product_set_shipping:[{
						required: true,
						message: '邮费不能为空',
						trigger: 'blur'
					},{
						type: 'number', 
						message: '邮费必须为数字值'
					}],
					product_sale_type: [{
						required: true,
						message: '商品类型不能为空',
						trigger: 'change'
					}],
				}
			}
		},
		methods: {
			edit(row) {
				this.dialogFormVisible = true;
				let temp = this.cloneObj(row);
				// console.log(temp)
				if (row) {
					this.title = '编辑商品邮费';
					this.item = temp;
					this.disabled_update = true
					this.item.product_sale_type = temp.id
					let product_set_shipping = temp.product_set_shipping;
					this.item.productSetShipping = []
					for(let i in product_set_shipping){
						let obj = {}
						obj['purchase_quanities'] = product_set_shipping[i].purchase_quanities
						obj['product_set_shipping'] = product_set_shipping[i].product_set_shipping

						this.item.productSetShipping.push(obj);
					}
					// console.log(this.item.productSetShipping)
				} else {
					this.title = '新增商品邮费';
					this.resetObj(this.item)
					this.disabled_update = false
					this.item.product_sale_type = ''
				}
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			onAdd(){
				let obj = {
					'purchase_quanities': '', // 购买数量
					'product_set_shipping': '',
				}
				this.item.productSetShipping.push(obj)
			},
			removeDomain(key){
				console.log(key)
				this.item.productSetShipping.splice(key,1);
			},
			submit() {
				// console.log(this.item);
				// return false;
				if(this.item.productSetShipping.length==0){
					this.$message.error('请至少设置一项邮费');
					return false;
				}
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.loading = true;
			// console.log(this.item.productSetShipping)
			// console.log(this.item)
			// return false;
			// console.log(this.item.product_sale_type)
						this.httpPost({
							url: '/admin/product/productSetShippingUpdate',
							data: this.item
						}).then((re) => {
			
							// console.log(re);
							this.dialogFormVisible = false;
							this.loading = false;
							this.resetObj(this.item)
							this.getProductSaleType();
							this.getProductSetShippingData();
						})

					} else {
						console.log('error submit!!');
						return false;
					}
				})
			
			},
			destroy(index, row) {
				console.log(index, row)
				let id = row.id
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/product/productSetShippingDelete', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getProductSetShippingData()
				})
			},
			getProductSaleType() {
				this.httpPost({
					url: '/admin/product/productSaleTypeList',
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.all_product_sale_type = temp;
			
				}).catch((err) => {})
			},
			getProductSetShippingData(){
				this.httpPost({
					url: '/admin/product/productSetShippingList',
					data:{
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.productSetShipData = temp;
					this.loading = false;
				
				}).catch((err) => {
					this.loading = false;
				})
			},
		},
		created(){
			this.getProductSetShippingData();
			this.getProductSaleType();
		}
	}
</script>

<style>
</style>
